import React from "react";

import { TopTournament } from "@api-types/offer/TopTournament";
import OfferIcons from "@components/icons/Offer";
import { SportInteractionTypeEnum } from "@data-types/analytics-tracker/SportInteractionTypeEnum";
import { redirect } from "@state";
import { getCurrentCulture } from "@utils";
import { analyticsTracker } from "@utils/analytics";

export default function TopTournamentItem(props: {
	tt: TopTournament;
	isDragging?: boolean;
}) {
	const culture = getCurrentCulture();

	return (
		<div
			className="quicklinks__item"
			onClick={() => {
				if (props.isDragging) {
					return null;
				}
				analyticsTracker.trackSportInteraction(
					SportInteractionTypeEnum.TopTournament,
					props.tt.abrv
				);
				redirect(`/${culture}/sports/full/promo/${props.tt.id}`);
			}}
		>
			<div className="quicklinks__content">
				<div className="quicklinks__icon">
					<OfferIcons
						type="tournament"
						sport={props.tt.sportCategory.sport.abrv}
						category={props.tt.sportCategory.abrv || ""}
						tournament={props.tt.abrv}
						wrapperClassName="quicklinks__icon__main"
						catOverSportClass="quicklinks__icon__sub"
						className="quicklinks__icon__inner u-icon"
					/>
				</div>
				<div className="quicklinks__text">
					{props.tt.sportCategory.abrv != props.tt.abrv && (
						<div className="quicklinks__subtitle">
							{props.tt.sportCategory.name}
						</div>
					)}
					<div className="quicklinks__title">{props.tt.name}</div>
				</div>
			</div>
		</div>
	);
}
